import styled from 'styled-components';

export const PaymentContainer = styled.div`
	margin: 0;
	background-color: ${({ theme }) => theme.grayColor};
	padding: 40px 32px;
	border-radius: 4px;

	@media (max-width: 600px) {
		padding: 30px 12px;
	}
`;

export const PaymentContent = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 60px;
	margin: 25px 150px 0 150px;

	@media (max-width: 1050px) {
		margin: 0;
	}

	@media (max-width: 600px) {
		grid-template-columns: repeat(1, 1fr);
		grid-gap: 20px;
		margin-top: 20px;
	}
`;

export const PaymentIcon = styled.svg`
	width: 40px;
	height: 40px;
	margin-bottom: 12px;
	fill: ${({ theme }) => theme.primaryColor};
	color: ${({ theme }) => theme.primaryColor};
	@media (max-width: 600px) {
		margin: 0;
	}
`;
export const PaymentItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;

	@media (max-width: 600px) {
		display: flex;
		flex-direction: row;
	}
`;
export const TextWrapper = styled.div`
	p {
		${({ theme }) => theme.typography.textL};
		color: ${({ theme }) => theme.primaryBlackColor};
		text-align: center;
		margin: 0;
		@media (max-width: 600px) {
			${({ theme }) => theme.typography.textM};
			text-align: left;
		}
	}

	@media (max-width: 600px) {
		margin-left: 15px;
	}
`;
